<template>
  <div>
    <search-form @search="handleSearch" ref="searchForm">
      <el-button type="primary" class="search-btn" :loading="loading" @click="handleSearch">{{ $t('common.search') }}</el-button>
    </search-form>

    <el-card v-loading="loading">
      <el-button type="primary" @click="handleCreate">{{ $t('cpTask.createTask') }}</el-button>

      <br>
      <br>

      <el-table :data="tableData">
        <el-table-column label="任务ID" prop="id" width="60"></el-table-column>
        <el-table-column label="任务名" prop="taskName" width="100" show-overflow-tooltip></el-table-column>
        <el-table-column label="组别" v-slot="{ row }" width="120">{{ contentTypeMap[row.contentType] }}</el-table-column>
        <el-table-column label="采买类型" v-slot="{ row }" width="100">{{ buyTypeMap[row.buyType] }}</el-table-column>
        <!-- <el-table-column label="版权方" prop="cpCompanyId" width="180"></el-table-column> -->
        <el-table-column label="入库进度" v-slot="{ row }" width="80">
          <status-flow :config="trackStatusList" :op-code="row.audioCode" @remind="handleRemind(row, REVIEW_TYPE_ENUM.TRACK.code)"></status-flow>
        </el-table-column>
        <el-table-column label="版权进度" v-slot="{ row }" width="80">
          <status-flow :config="cpStatusList" :op-code="row.cpCode" @remind="handleRemind(row, REVIEW_TYPE_ENUM.CP.code)"></status-flow>
        </el-table-column>
        <el-table-column label="商务负责人" prop="businessBroker" width="120"></el-table-column>
        <el-table-column label="创建时间" prop="insertTime" width="120"></el-table-column>
        <el-table-column label="是否启用" v-slot="{ row }" width="80">{{ validMap[row.isValid] }}</el-table-column>

        <el-table-column
          label="操作"
          v-slot="{ row }"
          width="150"
          align="center"
          fixed="right"
        >
          <el-button
            type="text"
            :disabled="cantEdit(row)"
            @click="handleEdit(row.id)"
          >
            <i class="el-icon-edit" />{{ $t('cpTask.editTask') }}
          </el-button>

          <span class="divide" />
          <el-button type="text" @click="handleDetail(row.id)">
            {{ $t('cpTask.detailTask') }}
          </el-button>

          <span class="divide" />
          <el-button type="text" :disabled="isCpTrackOnline" @click="handleJumpTrack(row.contract)">{{ $t('cpTask.findTracks') }}</el-button>

          <span class="divide" />
          <el-button type="text" @click="handleExport(row.contract)">{{ $t('cpTask.exportTracks') }}</el-button>

          <span class="divide" />
          <el-button type="text" @click="handleEnableTask(row)">{{ !!row.isValid ? $t('cpTask.stopTask') : $t('cpTask.runTask') }}</el-button>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSearch"
        @current-change="fetchData"
        :page-sizes="[10, 20, 50, 100]"
        :current-page.sync="pagination.current"
        :page-size.sync="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import cpTaskService from '@/api/cpTask'
import trackService from '@/api/track'
import { CpTask } from '@/models/CpTask'
import SearchForm from './components/SearchForm.vue'
import StatusFlow from './components/StatusFlow.vue'
import {
  REVIEW_TYPE_ENUM,
  contentTypeMap,
  buyTypeMap,
  trackStatusList,
  cpStatusList,
  validMap,
} from './const'

export default {
  name: 'CpTaskList',
  components: {
    SearchForm,
    StatusFlow

  },
  data() {
    return {
      REVIEW_TYPE_ENUM,
      contentTypeMap,
      buyTypeMap,
      trackStatusList,
      cpStatusList,
      validMap,

      loading: false,
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      tableData: []
    }
  },

  computed: {
    ...mapGetters([
      'isCpTrackOnline',
    ]),
  },

  mounted() {
    this.handleSearch()
  },

  methods: {
    handleSearch() {
      this.pagination.current = 1
      this.fetchData()
    },
    async fetchData() {
      const { pagination } = this
      const searchData = {
        page: pagination.current - 1,
        num: pagination.size,
        ...this.$refs.searchForm.formatForm
      }
      this.loading = true
      try {
        const { list, total } = await cpTaskService.find(searchData)
        this.tableData = (list || []).map(item => new CpTask(item))
        this.pagination.total = total
      } catch (error) {
        console.error(error)
        this.$message({
          type: 'error',
          message: `获取入库任务列表异常！(${error.message})`
        })
      }
      this.loading = false
    },
    handleCreate() {
      this.$router.open({ name: 'cpTaskDetail' })
    },
    // 禁止编辑，歌曲入库进度非商务提交、已入库且版权进度非商务提交、已审核
    cantEdit(row) {
      return ![-1, 3].includes(row.audioCode) && ![-1, 2].includes(row.cpCode)
    },
    handleEdit(id) {
      this.$router.open({ name: 'cpTaskDetail', query: { id } })
    },
    handleDetail(id) {
      this.$router.open({ name: 'cpTaskDetail', query: { id, readonly: true } })
    },
    async handleExport(contract) {
      this.$notify({
        title: '通知',
        showClose: true,
        message: '正在生成导出任务,请关注邮件或站内通知...',
        position: 'top-right',
        iconClass: 'el-icon-loading',
        duration: 2000
      })

      try {
        await trackService.exportAllData({ contract })
      } catch (err) {
        this.$message.error(err.message)
      }
    },
    handleJumpTrack(contract) {
      this.$router.open({ name: 'trackList', query: { contract } })
    },
    handleEnableTask(row) {
      const newValid = row.isValid ? 0 : 1
      this.$confirm(`确定要${newValid ? '启用' : '停用'}该任务吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        try {
          await cpTaskService.changeValid({ id: row.id, isValid: newValid })
          this.$message.success('操作成功')
          this.fetchData()
        } catch (error) {
          this.$message({
            type: 'error',
            message: `操作失败！(${error.message})`
          })
        }
      })
    },
    async handleRemind(row, reviewType) {
      const opCode = reviewType === REVIEW_TYPE_ENUM.TRACK.code ? row.audioCode : row.cpCode
      try {
        await cpTaskService.fastRemind({
          opCode,
          reviewType,
          taskId: row.id
        })
        this.$message.success('操作成功')
      } catch (error) {
        this.$message({
          type: 'error',
          message: `操作失败！(${error.message})`
        })
      }
    }
  }
}
</script>
